<template>
  <div>
    <div class="slogan">
      <p>答题过程中请勿刷新页面，系统会自动保存草稿；考试结束时间以实际时间为准。</p>
    </div>
    <el-alert
      v-if="saveStatusMessage"
      :title="saveStatusMessage"
      :type="saveStatusType"
      show-icon
      :closable="false"
      class="exam-status-alert">
    </el-alert>
    <el-container class="app-item-contain">
      <el-header class="align-center">
        <h1 style="font-size: 30px;">{{ form.paper.name }}</h1>
        <br>
        <span style="float: left; margin-top: -50px; ">
          <el-tag type="success" size="normal" style="font-weight: bold">开始时间: {{ form.begin_time }}</el-tag>
        </span>
        <span style="float: left; margin-top: -10px;" v-if="form.task_type === 0">
          <el-tag type="danger" size="normal" style="font-weight: bold">结束时间: {{ form.deadline }}</el-tag>
        </span>
        试卷总分: <span style="color: red;" class="sec-title">{{ form.paper.paper_score }}</span>
        <span class="sec-title">所属学科: {{ form.paper.subject_name }}</span>
        <span class="sec-title">考试时长: {{ form.task_duration }}min</span>
        <span class="sec-title">考试类型: {{ form.type_name }}</span>
        <span style="float: right; font-size: 20px;">
          考生姓名: &nbsp;&nbsp;<span style="color:darkblue">{{ form.student_name }}</span>
        </span>
        <el-divider></el-divider>
      </el-header>
      <br>
      <br>
      <el-main>
        <el-form :model="form" ref="form" v-loading="formLoading" label-width="100px">
          <el-row :key="index" v-for="(topic,index) in form.paper.topicItem">
            <h3>{{ topic.content }}</h3>
            <el-card class="exampaper-item-box" v-if="topic.titles.length!==0">
              <el-form-item :key="title.id" :label="index + 1 + '.'"
                            v-for="(title, index) in topic.titles"
                            class="exam-question-item" label-width="50px" :id="'question-'+ index">
                <StudentExamTitle :qType="title.title_type" :question="title"/>
              </el-form-item>
            </el-card>
          </el-row>
        </el-form>
      </el-main>
    </el-container>
    <div class="back-btn">
      <el-button icon="el-icon-s-promotion" type="danger" style="font-size: 16px;" :loading="isSubmitting" @click="open">提交试卷
      </el-button>
    </div>
    <div class="watch-block" v-if="form.task_type===0">
      <p style="margin-top: 18px;">{{ format_time }}</p>
    </div>
    <div class="app-footer">© 海之林科技 在线考试系统</div>
  </div>
</template>

<script>
import StudentExamTitle from "../../components/StudentExamTitle";

export default {
  name: 'StudentExam',
  components: {StudentExamTitle,},
  data() {
    return {
      form: {
        paper: {
          name: '',
          paper_score: '',
        }
      },
      formLoading: false,
      timer: null,
      duration: 0,
      remainingSeconds: 0,
      autoSaveTimer: null,
      localDraftKey: '',
      hasLoadedPaper: false,
      isSubmitting: false,
      saveStatusMessage: '',
      saveStatusType: 'info',
      format_time: '',
      format_sec: '00',
    }
  },
  created() {
    let id = this.$route.query.id
    this.localDraftKey = `student_exam_draft_${id}`
    if (id && parseInt(id) !== 0) {
      this.formLoading = true
      this.$http({
        url: this.$settings.BASE_URL + `/paper/student_paper/get_paper/`,
        params: {paper_id: id},
        method: 'get',
      }).then(res => {
        this.form = res.data.result
        this.duration = res.data.result.task_duration
        this.restoreLocalDraft()
        this.initRemainingSeconds()
        if (res.data.result.task_type === 0) {
          this.reduceTime()
        }
        this.startAutoSave()
        this.bindPageEvents()
        this.hasLoadedPaper = true
        this.formLoading = false
      }).catch(() => {
        this.formLoading = false
        this.saveStatusType = 'error'
        this.saveStatusMessage = '试卷加载失败，请检查网络后刷新页面。已加载的本地草稿不会被清除。'
      })
    }
  },
  methods: {
    getElapsedMinutes() {
      if (this.form.task_type !== 0) {
        return 0
      }
      let totalSeconds = Number(this.form.task_duration || 0) * 60
      let usedSeconds = totalSeconds - this.remainingSeconds
      if (usedSeconds < 0) {
        usedSeconds = 0
      }
      return Math.floor(usedSeconds / 60)
    },
    getDraftPayload() {
      return {
        saved_at: Date.now(),
        remaining_seconds: this.remainingSeconds,
        answers: this.form.paper.topicItem.map(topic => ({
          titles: topic.titles.map(title => ({
            id: title.id,
            blank: title.blank
          }))
        }))
      }
    },
    saveLocalDraft() {
      if (!this.hasLoadedPaper) {
        return
      }
      try {
        localStorage.setItem(this.localDraftKey, JSON.stringify(this.getDraftPayload()))
      } catch (e) {
        this.saveStatusType = 'warning'
        this.saveStatusMessage = '本地草稿保存失败，请不要关闭当前页面，并尽快联系监考人员。'
      }
    },
    clearLocalDraft() {
      localStorage.removeItem(this.localDraftKey)
    },
    restoreLocalDraft() {
      let raw = localStorage.getItem(this.localDraftKey)
      if (!raw) {
        return
      }
      try {
        let draft = JSON.parse(raw)
        let answerMap = {}
        ;(draft.answers || []).forEach(topic => {
          ;(topic.titles || []).forEach(title => {
            answerMap[title.id] = title.blank
          })
        })
        this.form.paper.topicItem.forEach(topic => {
          topic.titles.forEach(title => {
            if (Object.prototype.hasOwnProperty.call(answerMap, title.id)) {
              title.blank = answerMap[title.id]
            }
          })
        })
        if (this.form.task_type === 0 && draft.remaining_seconds !== undefined) {
          let elapsedSeconds = Math.floor((Date.now() - Number(draft.saved_at || Date.now())) / 1000)
          let restoredSeconds = Number(draft.remaining_seconds) - elapsedSeconds
          this.remainingSeconds = restoredSeconds > 0 ? restoredSeconds : 0
        }
      } catch (e) {
        this.clearLocalDraft()
      }
    },
    initRemainingSeconds() {
      let totalSeconds = Number(this.form.task_duration || 0) * 60
      if (!this.remainingSeconds) {
        let usedSeconds = Number(this.form.duration || 0) * 60
        this.remainingSeconds = totalSeconds - usedSeconds
      }
      if (this.remainingSeconds < 0) {
        this.remainingSeconds = 0
      }
      this.updateFormatTime()
    },
    updateFormatTime() {
      let minutes = Math.floor(this.remainingSeconds / 60)
      let seconds = this.remainingSeconds % 60
      let formatMin = minutes <= 9 ? `0${minutes}` : `${minutes}`
      let formatSec = seconds <= 9 ? `0${seconds}` : `${seconds}`
      this.format_sec = formatSec
      this.format_time = `${formatMin}:${formatSec}`
    },
    autoSaveDraft() {
      if (!this.hasLoadedPaper || this.isSubmitting) {
        return
      }
      this.saveLocalDraft()
      this.$http({
        url: this.$settings.BASE_URL + '/paper/student_index/save_draft/',
        method: 'post',
        timeout: 10000,
        silentError: true,
        data: {
          id: this.form.id,
          duration: this.getElapsedMinutes(),
          paper: this.form.paper,
        }
      }).then(res => {
        if (res.data.code === 20000) {
          this.clearLocalDraft()
          this.saveStatusMessage = ''
        } else {
          this.saveStatusType = 'warning'
          this.saveStatusMessage = res.data.msg || '自动保存失败，系统已保留本地草稿。'
        }
      }).catch(() => {
        this.saveStatusType = 'warning'
        this.saveStatusMessage = '网络波动，自动保存到服务器失败；系统已保留本地草稿，请继续答题，不要刷新页面。'
      })
    },
    startAutoSave() {
      clearInterval(this.autoSaveTimer)
      this.autoSaveTimer = setInterval(() => {
        this.autoSaveDraft()
      }, 15000)
    },
    beforeLeavePage() {
      this.saveLocalDraft()
    },
    bindPageEvents() {
      window.addEventListener('beforeunload', this.beforeLeavePage)
      document.addEventListener('visibilitychange', this.beforeLeavePage)
    },
    unbindPageEvents() {
      window.removeEventListener('beforeunload', this.beforeLeavePage)
      document.removeEventListener('visibilitychange', this.beforeLeavePage)
    },
    submit() {
      if (this.isSubmitting) {
        return
      }
      this.isSubmitting = true
      this.saveLocalDraft()
      if (this.form.task_type === 0) {
        this.form['duration'] = this.getElapsedMinutes()
      } else {
        this.form['duration'] = 0
      }
      this.$http({
        url: this.$settings.BASE_URL + '/paper/student_index/submit_paper/',
        method: 'post',
        timeout: 60000,
        data: this.form,
      }).then(res => {
        if (res.data.code === 20000) {
          this.$message({
            type: 'success',
            message: '交卷成功!',
            duration: 5000,
          });
          clearInterval(this.timer)
          clearInterval(this.autoSaveTimer)
          this.clearLocalDraft()
          this.$router.push('/StudentIndex')
        } else {
          this.isSubmitting = false
          this.$message({
            type: 'error',
            message: res.data.msg,
            duration: 5000,
          });
        }
      }).catch(() => {
        this.isSubmitting = false
        this.saveStatusType = 'error'
        this.saveStatusMessage = '交卷失败，答案已保存在本机草稿中。请不要关闭页面，检查网络后再次点击提交试卷。'
      })
    },
    open() {
      if (this.isSubmitting) {
        return
      }
      this.$confirm('试卷一旦提交将不能修改,确认提交答卷吗?', '提示', {
        confirmButtonText: '交卷',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.submit()
      }).catch(() => {
        this.$message({
          type: 'warning',
          message: '已取消交卷'
        });
      });
    },
    reduceTime() {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.remainingSeconds -= 1
        if (this.remainingSeconds < 0) {
          this.submit()
          clearInterval(this.timer)
          this.$notify({
            title: '考试时间已到',
            message: '考试已结束,您的答卷已自动提交,继续答题无效,',
            type: 'warning',
            duration: 20000,
          });
          return
        }
        this.updateFormatTime()
      }, 1000)
    }
  },
  watch: {
    'form.paper.topicItem': {
      handler() {
        this.saveLocalDraft()
      },
      deep: true
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    clearInterval(this.autoSaveTimer)
    this.unbindPageEvents()
    this.saveLocalDraft()
  },
  computed: {}
}
</script>

<style lang="css" scoped>
.exam-status-alert {
  width: min(960px, calc(100% - 32px));
  margin: 12px auto 0;
}

.watch-block {
  color: whitesmoke;
  background-color: rgba(5, 20, 10, 0.5);
  height: 60px;
  width: 60px;
  border-radius: 50%;
  position: fixed;
  right: 20px;
  bottom: 40px;
  text-align: center;
  border: solid mediumseagreen 3px;
}

.back-btn {
  height: 80px;
  margin-top: 20px;
  margin-left: 697px;
}

.align-center {
  text-align: center
}

.exam-question-item {
  padding: 10px;
}

.el-form-item__label {
  font-size: 15px !important;
}


.question-title-padding {
  padding-left: 25px;
  padding-right: 25px;
}

.sec-title {
  margin-right: 50px;
  font-weight: normal;
}

.slogan {
  background-color: #eee;
  height: 40px;
}

.slogan p {
  width: 1200px;
  margin: 0 auto;
  color: #aaa;
  font-size: 13px;
  line-height: 40px;
}

</style>
